<div class="layout-rightpanel-wrapper">
    <div class="layout-rightpanel-header" fxLayoutAlign="center center">
        <h1 class="tenant">Features</h1>
    </div>

    <div class="layout-rightpanel-content p-fluid" fxLayout="column">
        <section class="page-content">
            <div class="content-wrapper tw-flex tw-flex-col" fxLayout="column" fxLayoutGap="10px"
                [formGroup]="this.form.controls['show']">

                <div *ngFor="let preview of this.shownPreviews; index as i" fxFlex fxLayoutAlign="space-between center">
                    <label>{{preview.displayName}}: </label>
                    <p-inputSwitch [formControlName]="preview.id"></p-inputSwitch>
                </div>

            </div>
        </section>
    </div>

</div>
